import { render, staticRenderFns } from "./algorithm.vue?vue&type=template&id=4726ddec&"
import script from "./algorithm.vue?vue&type=script&lang=js&"
export * from "./algorithm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports